export default function () {
  return {
    enrollableFlows: [],
    isEnrollableFlowsLoading: false
  }
}
